module.exports = {
    abrir: 'Abrir',
    abrirNovaAba: 'Abrir anexo em nova aba',
    aguardeSalaVideo: 'Aguarde enquanto configuramos a sala de atendimento...',
    anexar: 'Anexar',
    anexarArquivo: 'Anexar arquivos',
    anexos: 'Anexos',
    atendimentoEncerrado: 'Atendimento Encerrado!',
    atendimentoFinalizado: 'Atendimento finalizado com sucesso',
    atrasado: 'O tempo de acesso a este teleatendimento expirou. Por favor, entre em contato com a administração para mais informações.',
    avisoSemConexao: 'Ops! Parece que perdemos a conexão com o servidor. Verifique sua conexão com a internet e aguarde, o sistema será recarregado automaticamente assim que a conexão for restabelecida. Se preferir, você pode recarregar manualmente clicando <a href="javascript:window.location.reload(true)"><b>aqui</b></a>.',
    buscarAnexo: 'Buscar',
    chamadaVideo: 'Iniciar atendimento por vídeo',
    chat: 'Chat',
    chegouCedo: 'Parece que você chegou cedo. Aguarde o horário do seu atendimento. A sala de atendimento só ficará disponível 15 minutos antes do horário agendado.',
    confirmarFinalizacao: 'Você confirma o encerramento deste atendimento? Ao encerrar o atendimento esta sala de áudio e vídeo ficará indisponível para uso posterior.',
    confirmarFinalizarAtendimento: 'Você tem certeza que deseja finalizar este atendimento?',
    digiteMensagem: 'Digite sua mensagem...',
    enviandoArquivo: 'Enviando arquivo...',
    enviarMensagem: 'Enviar mensagem',
    erroEnvioArquivo: 'Ocorreu um erro no envio do anexo. Por favor, tente novamente mais tarde.',
    erroToken: 'Ocorreu um erro na validação do seu token de acesso. Por favor, verifique se o token informado está correto.',
    fecharChamadaVideo: 'Fechar atendimento por vídeo',
    finalizarAtendimento: 'Finalizar atendimento',
    formatoData: 'DD/MM/YYYY',
    historicoAtendimento: 'Histórico do atendimento',
    historicoChat: 'Histórico do chat',
    inserirAnexo: 'Inserir anexo',
    jaOnline: 'Você já está conectado no módulo de Teleatendimento através de outra aba, navegador ou dispotivo.',
    mensagemAnexo: 'Clique no botão ao lado para inserir um novo anexo',
    mensagemEncerrado: 'Este teleatendimento foi encerrado e por isso não é mais possível realizar conversas por texto e chamadas de áudio e vídeo.',
    mensagemHistorico: 'Você ainda tem acesso ao histórico da(s) conversa(s) por texto e a lista de anexos enviados.',
    naoAutorizado: 'Não autorizado',
    nenhumaMensagemEnviadaAtendimento: 'Nenhuma mensagem de texto foi enviada neste atendimento.',
    nenhumAnexo: 'Nenhum anexo encontrado',
    observacao: 'Digite uma observação',
    selecionarEmoji: 'Selecionar emoji',
    somenteImagens: 'Somente imagens podem ser coladas diretamente no chat. Para arquivos de outros formatos, use a opção de anexar manualmente.',
    sucessoEnvioAnexo: 'Anexo enviado com sucesso.',
    teleatendimento: 'Teleatendimento',
    textoAguarde: 'Aguarde, em breve você será atendido.',
    textoAtendimentoFinalizado: 'O atendente encerrou este atendimento.',
    textoConectado: 'se conectou no chat.',
    termoConsentimentoTeleconsulta: 'Termo de Consentimento Livre e Esclarecido do Paciente',
    termoConsentimentoSalvo: 'Termo de consentimento salvo com sucesso.',
    termoConsentimentoErroSalvar: 'Erro ao salvar termo de consentimento. Por favor, tente novamente ou entre em contato com o suporte.',
    termoConsentimentoTexto: () => `&nbsp;&nbsp;O Senhor(a) está sendo convidado a dar ciência (concordar ou discordar) com a realização de atendimento na modalidade por Teleconsulta, bem como o uso de imagem, o qual ficará sob sigilo 
    profissional e à proteção das informações pessoais, nos termos da Lei Nº 14.510/2022 e pela Lei Nº 13.709/2018 de Proteção de Dados- LGPD. Seu Teleatendimento, será realizado pelo sistema de Telemedicina e Telessaúde – STT.
    <br/>
    <h4>DISPOSIÇÕES PRELIMINARES</h4>
    &nbsp;&nbsp;Estou ciente de que as informações por mim prestadas, via online, serão armazenadas no Prontuário Eletrônico que ficarão guardados sob sigilo todas as informações de acordo com a Lei Nº 
    13.709/2018. Sendo este sigilo, resguardado tanto pelos pacientes/usuário quanto pelo profissional de saúde, não sendo permitido fotografar, gravar, registrar, compartilhar ou publicar de qualquer forma a 
    imagem do atendimento realizado sem prévia autorização dos participantes. 
    <br/>
    &nbsp;&nbsp;Declaro que estou ciente de que as informações por mim prestadas poderão ser utilizadas para fins de pesquisa clínica e epidemiológica sendo resguardadas as informações que permitam a minha identificação, preservando o sigilo, conforme exigido por lei.
    <br/>
    <h4>LIMITAÇÕES</h4>
    &nbsp;&nbsp;Tenho ciência que o teleatendimento é limitado por não permitir a realização do exame físico presencial; podendo em algumas situações o profissional de saúde solicitar meu comparecimento como paciente para consulta presencial.
    <br/>
    &nbsp;&nbsp;Como usuário/paciente estou ciente de que os meios de comunicação online (a distância), estão sujeitos às seguintes situações:
    <ul>
        <li>Perda de conexão durante o atendimento virtual;</li>
        <li>Necessidade de nova conexão para continuidade do atendimento virtual;</li>
        <li>Variação no estabelecimento da conexão;</li>
        <li>Necessidade de novo agendamento para o atendimento diante de falha técnica.</li>
    </ul>
    <h4>DISPOSIÇÕES FINAIS</h4>
    &nbsp;&nbsp;Declaro que estou ciente de que o atendimento via Teleconsulta foi escolhido e aceito por mim. Após ter as informações necessárias ao meu teleatendimento, espontaneamente dou o meu 
    consentimento, bem como prestarei as informações necessárias a meu respeito para realização dessa forma de atendimento. Aceito o recebimento via remota de solicitações de receitas, exames, atestados 
    e qualquer outro documento que se fizer necessário ao seguimento de meu tratamento. 
    <br/>
    &nbsp;&nbsp;Confirmo que compreendi e concordo com todos os termos deste Termo de Consentimento Livre Esclarecido. 
    <br/>
    <br/>
    Declaro que concordo em participar desse Teleatendimento.
    <br/>
    <br/>
    AO CONCORDAR, dou livremente meu consentimento para participar desta Teleconsulta.`,
    textoDesconectado: 'se desconectou do chat.',
    tituloJanela: 'Janela de teleatendimento'
}